module.exports = __webpack_public_path__ + "img/32.4de40eb9.jpg";